import { VideoPlayerButton } from '../web-components/video-player-button';